//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TextInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator: value => [
        'text',
        'email',
        'search',
        'tel'
      ].includes(value)
    },
    mode: {
      type: String,
      default: '',
      validator: value => [
        '',
        'grey'
      ].includes(value)
    }
  }
}
